import lodash from 'lodash'
import { restfulClient } from "@/api"


const restfulModule = {

  state: {
    path: '',
    defaultRels: [],
    defaultQuery: {},
    collection: {
      collection: [],
      meta: { total: 0 }
    },
    document: {
      document: {},
      meta: {}
    }
  },

  getters: {
    collection: state => state.collection.collection,
    pagination: state => state.collection.meta.pagination,
    total: state => state.collection.meta.total,
    document: state => state.document.document,
    etag: state => state.document.meta.etag
  },

  mutations: {

    setCollection(state, collection) {
      state.collection = collection
    },

    setDocument(state, document) {
      state.document = document
    }

  },

  actions: {

    /**
     * @param {QueryPrams} queryPrams
     */
    async find({ state }, queryPrams) {
      queryPrams.query = { ...state.defaultQuery, ...queryPrams.query }
      queryPrams.withRels = lodash.uniq([...(queryPrams.withRels || []), ...state.defaultRels])
      return restfulClient.getCollection(state.path, queryPrams)
    },

    /**
     * @param {QueryPrams} queryPrams
     */
    async findOne({ dispatch }, queryPrams) {
      const collection = await dispatch('find', queryPrams)
      return collection.collection[0]
    },

    /**
     * @param {QueryPrams} queryPrams
     */
    async collection({ commit, dispatch, state }, queryPrams) {
      const collection = await dispatch('find', queryPrams)
      commit('setCollection', collection)
      return state.collection
    },

    async document({ commit, state }, id, { withRels = [] } = {}) {
      withRels = lodash.uniq([...withRels, ...state.defaultRels])
      const document = await restfulClient.getDocument(state.path, id, withRels)
      commit('setDocument', document)
      return state.document
    },

    async create({ state }, data) {
      return restfulClient.create(state.path, data)
    },

    async batchCreate({ state }, dataArray) {
      return restfulClient.batchCreate(state.path, dataArray)
    },

    async update({ state }, data) {
      const { id, ...props } = data
      return restfulClient.update(state.path, id, props)
    },

    /**
     * @param {QueryPrams} queryPrams
     * @param {array} data
     */
    async batchUpdate({ state }, queryPrams, data) {
      return restfulClient.batchUpdate(state.path, queryPrams, data)
    },

    async remove({ state }, data) {
      const { id } = data
      return restfulClient.remove(state.path, id)
    }
  }

}

const moduleProps = ['state', 'getters', 'mutations', 'actions']
export default function createRestfulModule(module, namespaced = true) {
  module.namespaced = namespaced
  moduleProps.forEach(prop => {
    module[prop] = { ...restfulModule[prop], ...(module[prop] || {}) }
  })
  return module
}
